<template>
  <div class="choose-audio">
    <h3>{{ $t('check.选择扬声器') }}</h3>
    <ul class="device-list">
      <li
        v-for="device in AudioOutPutList"
        :key="device.deviceId"
        @click="setAudioDevice(device.deviceId)"
      >
        <span class="device-name">{{ device.label }}</span>
        <span v-if="device.deviceId == AudioOutPutDeviceId" class="checkmark">
          <i class="icon-selected"></i>
        </span>
      </li>
    </ul>
    <div class="divider-line"></div>
    <h3>{{ $t('check.选择麦克风') }}</h3>
    <ul class="device-list">
      <li
        v-for="device in AudioInputList"
        :key="device.deviceId"
        @click="changeVideoOrAudioTrack(device.deviceId)"
      >
        <span class="device-name">{{ device.label }}</span>
        <span v-if="device.deviceId === AudioInputDeviceId" class="checkmark">
          <i class="icon-selected"></i>
        </span>
      </li>
    </ul>
    <div class="divider-line"></div>
    <h3 @click.stop="setSetting" class="h-setting">{{ $t('check.音频设置') }}</h3>
  </div>
</template>
<script>
import Bus from '@/components/doc/bus';
import mediaError from '@/mixins/mediaError';
export default {
  name: 'media',
  mixins: [mediaError],
  data() {
    return {
      VideoInputList: [],
      AudioInputList: [],
      AudioOutPutList: [],
      AudioInputDeviceId: null,
      AudioOutPutDeviceId: null,
      curSelectAudioInputId: null,
      audioEl: null,
      VideoInputDeviceId: null,
      isPlaying: false
    };
  },
  props: {
    showAudio: false
  },
  computed: {
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
    publishStream() {
      let pubStream = null;
      if (
        this.rtcClient.RTCRoom.webrtc &&
        this.rtcClient.RTCRoom.webrtc.publishLocal &&
        this.rtcClient.RTCRoom.webrtc.publishLocal.publishStream
      ) {
        pubStream = this.rtcClient.RTCRoom.webrtc.publishLocal.publishStream;
      }
      return pubStream;
    },
    publication() {
      let pubLocallication = null;
      if (
        this.rtcClient.RTCRoom.webrtc &&
        this.rtcClient.RTCRoom.webrtc.publishLocal &&
        this.rtcClient.RTCRoom.webrtc.publishLocal.publication
      ) {
        pubLocallication = this.rtcClient.RTCRoom.webrtc.publishLocal.publication;
      }
      return pubLocallication;
    },
    createVideoorAudioStream() {
      let createStream = null;
      if (this.rtcClient.RTCRoom.webrtc && this.rtcClient.RTCRoom.webrtc.createVideoorAudioStream) {
        createStream = this.rtcClient.RTCRoom.webrtc.createVideoorAudioStream;
      }
      return createStream;
    },
    changeDevice() {
      let chaneDeviceFun = null;
      if (this.rtcClient.RTCRoom.webrtc && this.rtcClient.RTCRoom.webrtc.changeDevice) {
        chaneDeviceFun = this.rtcClient.RTCRoom.webrtc.changeDevice;
      }
      return chaneDeviceFun;
    },
    publishLocalStream() {
      let pubLocalStream = null;
      if (this.rtcClient.RTCRoom.webrtc && this.rtcClient.RTCRoom.webrtc.publishLocalStream) {
        pubLocalStream = this.rtcClient.RTCRoom.webrtc.publishLocalStream;
      }
      return pubLocalStream;
    },
    hasStreamAndCanInit() {
      return this.canInitMedia && this.publishStream;
    },
    audioInputDeviceId() {
      return this.$store.getters.AudioInputDeviceId;
    },
    videoInputDeviceIds() {
      return this.$store.getters.VideoInputDeviceId;
    },
    audioOutputDeviceId() {
      return this.$store.getters.AudioOutputDeviceId;
    },

  },
  watch: {
    audioOutputDeviceId: {
      immediate: true,
      handler(val) {
        this.AudioOutPutDeviceId = val
      }
    },
    audioInputDeviceId: {
      immediate: true,
      handler(val) {
        this.AudioInputDeviceId = val
      }
    },
  },
  beforeDestroy() {
    Bus.$off('ondevicechange');
  },
  mounted() {
    this.initAudio();
    Bus.$on('ondevicechange', () => {
      console.log('ondevicechange audio')
      if (this.showAudio) {
        this.initAudio();
      }
    });
  },
  methods: {
    setSetting() {
      this.$emit('close')
      this.$store.commit('SHOW_SETTING', true);
    },
    async initAudio() {
      let deviceInfos = await navigator.mediaDevices.enumerateDevices();
      console.log(deviceInfos, "设备列表audio");
      this.VideoInputList = deviceInfos.filter((d) => {
        return d.kind === "videoinput";
      });
      this.AudioInputList = deviceInfos.filter((d) => {
        return d.kind === "audioinput";
      });
      this.AudioOutPutList = deviceInfos.filter((d) => {
        return d.kind === "audiooutput";
      });
      let audioInputFlag = this.AudioInputList.find(item => item.deviceId == this.audioInputDeviceId)
      let audioOutFlag = this.AudioOutPutList.find(item => item.deviceId == this.audioOutputDeviceId)
      let videoFlag = this.VideoInputList.find(item => item.deviceId == this.videoInputDeviceIds)

      this.VideoInputDeviceId = null;
      this.AudioInputDeviceId = null;
      // 如果有发布流
      if (this.publishStream) {
        if (this.publishStream.getVideoTracks()[0] != undefined) {
          if (document.getElementById("localVideo")) {
            document.getElementById("localVideo").srcObject = this.publishStream;
          }
          if (this.videoInputDeviceIds && videoFlag) {
            this.VideoInputDeviceId = this.videoInputDeviceIds;
          } else {
            this.VideoInputDeviceId = this.publishStream.getVideoTracks()[0].getSettings().deviceId;
          }
          //根据媒体信息返回当前选择的分辨率
          this.mediaQuality = this.publishStream.getVideoTracks()[0].getSettings().width
        } else {
          if (document.getElementById("localVideo")) {
            document.getElementById("localVideo").srcObject = null;
          }
        }
        if ( this.audioInputDeviceId && audioInputFlag) {
          this.AudioInputDeviceId = this.audioInputDeviceId
          this.curSelectAudioInputId = JSON.parse(JSON.stringify(this.AudioInputDeviceId));

        }  else if (this.publishStream.getAudioTracks()[0]) {
          this.AudioInputDeviceId = this.publishStream.getAudioTracks()[0].getSettings().deviceId;
          this.curSelectAudioInputId = JSON.parse(JSON.stringify(this.AudioInputDeviceId));

        }
      } else {
        this.AudioInputDeviceId = this.AudioInputList[0].deviceId;
        this.VideoInputDeviceId = this.VideoInputList[0].deviceId;
      }
      if (this.audioOutputDeviceId && audioOutFlag) {
        this.AudioOutPutDeviceId = this.audioOutputDeviceId
      } else if ( (document.getElementById("live") && document.getElementById("live").sinkId && this.AudioOutPutList.length)) {
        let audioOutFlag2 = this.AudioOutPutList.find(item => item.deviceId ==  document.getElementById("live").sinkId)
        if (audioOutFlag2) {
          this.AudioOutPutDeviceId = document.getElementById("live").sinkId;
        } else {
          this.AudioOutPutDeviceId = 'default'
          this.setAudioDevice('default')
        }
      } else {
        this.AudioOutPutDeviceId = 'default'
        this.setAudioDevice('default')
      }
      this.$store.commit("SET_AUDIOOUTPUTDEVICEID", this.AudioOutPutDeviceId);
      this.$store.commit('SET_AUDIOINPUTDEVICEID', this.AudioInputDeviceId);
      this.$store.commit("SET_VIDEOINPUTDEVICEID", this.VideoInputDeviceId);

    },
    setAudioDevice(value) {
      this.AudioOutPutDeviceId = value;
      if (document.getElementById("live")) {
        document.getElementById("live").setSinkId(value);
      }
      this.$store.commit('SET_AUDIOOUTPUTDEVICEID', this.AudioOutPutDeviceId);
      this.stopAudioDestination();
    },
    stopAudioDestination() {
      this.isPlaying = false;
      if (this.audioEl) {
        this.audioEl.pause();
        this.audioEl = null;
      }
    },
    async changeVideoOrAudioTrack(DeviceId) {
      let deviceInfo = { micDeviceId: DeviceId };
      try {
        let replaceTrackInfo = await this.replaceTrack(deviceInfo, 'changeDevice');
        console.log(replaceTrackInfo, 'replaceTrackInfo');
        if (replaceTrackInfo && replaceTrackInfo.code && replaceTrackInfo.code == 1) {
          // 获取摄像头错误信息
          console.log(replaceTrackInfo, 'error');

            this.getUserMediaError(replaceTrackInfo.info.name);
        } else {

            this.getUserMediaError('success');
          this.AudioInputDeviceId = DeviceId;
          this.$store.commit('SET_AUDIOINPUTDEVICEID', this.AudioInputDeviceId);
          console.log(replaceTrackInfo, 'success', DeviceId, this.audioInputDeviceId);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async replaceTrack(deviceInfo, status) {
      var isExitVideoOrAudio = false;
      if (
        this.publishStream &&
        this.publishStream.getVideoTracks()[0] &&
        this.publishStream.getAudioTracks()[0]
      ) {
        isExitVideoOrAudio = true;
      }
      var deviceId = deviceInfo.micDeviceId;
      var publishStream = await this.rtcClient.RTCRoom.webrtc
        .createVideoorAudioStream(deviceId, 'audio', status)
        .catch((err) => {
          this.loading = false;
          return err;
        });
      if (publishStream && publishStream.code == 1) return publishStream;
      if (isExitVideoOrAudio) {
        this.changeDevice(this.publication, this.publishStream);
        Bus.$emit('addAudioTrackEvent');
      } else {
        if (this.publication) {
          this.publication
            .stop()
            .then(async () => {
              let publishMsg = await this.rtcClient.RTCRoom.webrtc
                .publishLocalStream(
                  {
                    VideoInputDeviceId: this.videoInputDeviceId,
                    AudioInputDeviceId: this.AudioInputDeviceId
                  },
                  {
                    video: {
                      deviceId: this.videoInputDeviceId
                    }
                  },
                  { video: { enabled: false } }
                )
                .catch((err) => {
                  this.loading = false;
                  return err;
                });
              if (publishMsg.code == 0) {
                this.publishAfter(0, publishMsg.data);
              }

              Bus.$emit('addAudioTrackEvent');
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          let publishMsg = await this.rtcClient.RTCRoom.webrtc
            .publishLocalStream(
              {
                VideoInputDeviceId: this.videoInputDeviceId,
                AudioInputDeviceId: this.AudioInputDeviceId
              },
              {
                video: {
                  deviceId: this.videoInputDeviceId
                }
              },
              { video: { enabled: false } }
            )
            .catch((err) => {
              this.loading = false;
              return err;
            });
          if (publishMsg.code == 0) {
            this.publishAfter(0, publishMsg.data);
          }
          Bus.$emit('addAudioTrackEvent');
        }
      }
    },
    publishAfter() {}
  }
};
</script>
<style lang="scss" scoped>
.choose-audio {
  min-width: 166px;
  min-height: 222px;
  z-index: 800;
  position: absolute;
  left: 57px;
  bottom: 6px;
  background: #212442;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  color: #acb2bf;
  font-size: 12px;
  padding: 0 10px;
}
[data-theme='Orange'] .choose-audio {
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
}
h3 {
  margin: 10px;
  font-size: 12px;
  color: #8a8f99;
  text-align: left;
  font-weight: 500;
}

.h-setting {
  color: #ffffff;
}

[data-theme='Orange'] .h-setting {
  color: #acb2bf;
}

.divider-line {
  border-bottom: 1px solid #3d3f59;
  margin: 10px 0;
}
[data-theme='Orange'] .divider-line {
  border-bottom: 1px solid #ebebeb;
}

.device-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.device-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
  cursor: pointer;
}

.device-list li:hover {
  background-color: #3e6f99;
}

[data-theme='Orange'] li:hover {
  background-color: #ebebeb;
}
.device-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 176px;
  color: #ffffff;
}
[data-theme='Orange'] .device-name {
  color: #acb2bf;
}

.checkmark {
  margin-left: 10px;
  color: #3986ee;
  font-weight: bold;
}
.icon-selected {
  width: 12px;
  height: 8px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('../../svg/selected.svg');
}
[data-theme='Orange'] .icon-selected {
  background-image: url('../../svg/selected-yellow.svg');
}
</style>
